// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

:root {
  --text-color: #e2e2e2;
  --bg-color: #2e2f31;
  --bg-color-secondary: #161b22;
  --bg-color-tertiary: #21262c;
  --border-color: #30363d;
  --box-shadow: #282a32;
  --card-shadow: rgba(0, 0, 0, .3);
  --black: #fff;
  --dark-grey: #999;
  --light-grey: #666;
  --white: #000;
  --grey3: #bbb;
  --grey12: #333;
  --grey14: #111;
  --bg-color-light: #161b22;
  --bg-color-back: #2a112a;
  --bg-color-float: #161b22;
  --bg-color-blur: rgba(37, 39, 42, .9);
  --bg-color-float-blur: rgba(22, 27, 34, .9);
  --text-color-light: #e5e5e5;
  --text-color-lighter: #e8e8e8;
  --text-color-bright: #eeeeee;
  --border-color-light: #2e333a;
  --border-color-dark: #394048;
  --theme-color: #3eaf7c;
  --navbar-height: 3.75rem;
  --navbar-horizontal-padding: 1.5rem;
  --navbar-vertical-padding: 0.7rem;
  --navbar-mobile-height: 3.25rem;
  --navbar-mobile-horizontal-padding: 1rem;
  --navbar-mobile-vertical-padding: .5rem;
  --navbar-bg-color: var(--bg-color-blur);
  --sidebar-bg-color: var(--bg-color-blur);
  --sidebar-width: 18rem;
  --sidebar-mobile-width: 16rem;
  --content-width: 780px;
  --home-page-width: 1160px;
  --font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", STHeiti, "Microsoft YaHei", SimSun, sans-serif;
  --font-family-heading: Georgia Pro, Crimson, Georgia, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", STHeiti, "Microsoft YaHei", SimSun, sans-serif;
  --font-family-mono: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  --line-numbers-width: 2.5rem;
  --color-transition: .3s ease;
  --transform-transition: .3s ease;
  --vp-bg: var(--bg-color);
  --vp-bgl: var(--bg-color-light);
  --vp-bglt: var(--bg-color-tertiary);
  --vp-c: var(--text-color);
  --vp-cl: var(--text-color-light);
  --vp-clt: var(--text-color-lighter);
  --vp-brc: var(--border-color);
  --vp-brcd: var(--border-color-dark);
  --vp-tc: var(--theme-color);
  --vp-tcl: var(--theme-color-light);
  --vp-ct: var(--color-transition);
  --vp-tt: var(--transform-transition);

  --warning-border-color: #e6a700;
  --warning-code-bg-color: rgb(230 167 0 / 15%);
  --warning-bg-color: #4d3800;

  --theme-color-dark: #389e70;
  --theme-color-light: #4abf8a;
  --theme-color-mask: rgba(62, 175, 124, .15);

  --badge-tip-color: #42b983;
  --badge-warning-color: #f4cd00;
  --badge-danger-color: #f55;
  --badge-info-color: #0295ff;
  --badge-note-color: #666;
}

[data-bs-theme="dark"] .navbar {
  --bs-navbar-color: #ea3377; 
}

[data-bs-theme="dark"] {
  --bs-body-bg: #140814; 
  --bg-color: #2a112a;  
  --bs-secondary-color: rgba(255, 255, 255, 0.5);
  --bg-color-blur: rgba(42, 17, 41, .9);
  --bs-nav-link-color: #ea3377; 
  --bs-link-color: #ea3377; 
  --bs-emphasis-color-rgb: #ea3377; 
  --text-color: #fff; 
  --link-color: #ea3377;
  --link-hover-color: #fff;
  --bg-color-navbar: #1b1020;
  --bg-color-navbar-hover: #841a41;
  --bs-border-color: #664e57;
  --bs-secondary-bg: #1b1020;
  --bs-link-color-rgb: 234, 51, 119;
}

.theme-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.admin-page-wrapper {
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding-top: calc(var(--navbar-height) + 2rem);
  padding-bottom: 2rem;
  min-height: calc(100vh - var(--navbar-height));
}

.admin-page-wrapper.main-content {
  margin-left: 250px;
  transition: margin-left 0.3s ease;
  padding-left: 2rem;
  padding-right: 2rem;
  max-width: calc(100vw - 250px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
}

.admin-page-wrapper.main-content > * {
  width: 100%;
  max-width: 1200px; /* Adjust this value based on your preferred content width */
}

footer {
  margin: .5rem 1rem;
  font-size: 14px;
}

.footer-wrapper {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding-block: .75rem;
  padding-inline: calc(var(--sidebar-space) + 2rem) 2rem;
  border-top: 1px solid var(--border-color);
  color: var(--dark-grey);
  text-align: center;
  transition: border-top-color var(--color-transition),background var(--color-transition),padding var(--transform-transition);
}

.footer-wrapper > div {
  flex: 1 1;
  padding: 0 1rem;
  min-width: 200px;
}

.footer-wrapper .footer {
  text-align: left;
}

.footer-wrapper .copyright {
  text-align: right;
}

.footer-wrapper .terms {
  text-align: center;
}

/* Modal */
.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 800px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: #e2e2e2;
  --bs-modal-bg: #1e1e1e;
  --bs-modal-border-color: rgb(255 255 255 / 18%);
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.5rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.5rem - 1px);
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: #49494c;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 1px;
}

.modal-backdrop {
  opacity:0.9 !important;
}

.modal-content {
  background: none;
  /*border: transparent;*/
  font-size: 0.9rem;
  font-weight: 600;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: none;
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);
  background-color: var(--bs-modal-footer-bg);
  border-top: none;
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}

/* Buttons */
[data-bs-theme="light"] .btn-primary {
  --bs-btn-color: #000;
  --bs-btn-bg: #ea3377;
  --bs-btn-border-color: #b8e986;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff4c4c;
  --bs-btn-hover-border-color: #ff4c4c;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff4c4c;
  --bs-btn-active-border-color: #ff4c4c;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d7e5c9;
  --bs-btn-disabled-border-color: #d7e5c9;
}

[data-bs-theme="dark"] .btn-primary {
  --bs-btn-color: #ffaecc;
  --bs-btn-bg: #8d1642;
  --bs-btn-border-color: #ea3377;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff4c4c;
  --bs-btn-hover-border-color: #ff4c4c;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff4c4c;
  --bs-btn-active-border-color: #ff4c4c;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d7e5c9;
  --bs-btn-disabled-border-color: #d7e5c9;
}

[data-bs-theme="light"] .btn-outline-primary {
  --bs-btn-color: #000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #ff4c4c;
  --bs-btn-hover-border-color: #ff4c4c;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #ff4c4c;
  --bs-btn-active-border-color: #ff4c4c;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d7e5c9;
  --bs-btn-disabled-border-color: #d7e5c9;
  --bs-gradient: none;
}

[data-bs-theme="dark"] .btn-outline-primary {
  --bs-btn-color: #ffffff;
  --bs-btn-border-color: #fffefe;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgba(42, 17, 41, .9);
  --bs-btn-hover-border-color: #ff4c4c;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #8d1642;
  --bs-btn-active-border-color: #ff4c4c;
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #d7e5c9;
  --bs-btn-disabled-border-color: #d7e5c9;
  --bs-gradient: none;
}

.filter-buttons {
  display: flex;
  justify-content: flex-end;
}

.title{
  margin-bottom: 30px;
}

.card {
  box-shadow: 0 0 41px 4px #00000080;
}

.card-container {
  display: flex;
  flex-direction: column;
}

/* Form Group */
.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.form-group input,
.form-group textarea {
  border-width: 2px;
}

.form-group label {
  width: 200px;
  margin-right: 10px;
  text-align: right;
}

.form-select {
  border-width: 2px;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
}

.checkbox-item {
  display: block;
  margin-bottom: 5px;
}

.tooltip {
  position: absolute !important;
}

/* Toggle Switch Styles - Shared component */
.custom-toggle {
  position: relative;
  display: inline-block;
  width: 35px;
  height: 15px;
}

.custom-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 13px;
  width: 13px;
  left: 3px;
  bottom: 1px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(18px);
}

/* React Select - Dark theme styles */
.dark-select__control {
  background-color: var(--bs-body-bg) !important;
  color: #e0e0e0 !important;
  border: 2px solid var(--bs-border-color) !important;
}

.dark-select__placeholder {
  color: #aaa !important;
}

.dark-select__control--is-focused {
  border-color: #6200ea !important;
  box-shadow: 0 0 5px rgba(98, 0, 234, 0.8) !important;
}

.dark-select__menu {
  background-color: #1f1f1f !important;
  color: #e0e0e0 !important;
}

.dark-select__option {
  background-color: #1f1f1f !important;
  color: #e0e0e0 !important;
}

.dark-select__option--is-selected {
  background-color: #6200ea !important;
  color: #fff !important;
}

.dark-select__option--is-focused {
  background-color: #333 !important;
}

.dark-select__single-value {
  color: #fff !important;
}

.dark-select__input-container {
  color: #fff !important;
}

/* CRT Model Tag Styles */
.selected-crt-models {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.crt-model-tag {
  display: inline-flex;
  align-items: center;
  background-color: #f0f0f0;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
}

.crt-model-tag .btn-close {
  width: 16px;
  height: 16px;
  margin-left: 8px;
  padding: 0;
  font-size: 10px;
  opacity: 0.5;
}

.crt-model-tag .btn-close:hover {
  opacity: 1;
}

.admin-page-wrapper.main-content.with-sidebar-collapsed {
  margin-left: 85px;
  max-width: calc(100vw - 85px);
}

@media (max-width: 768px) {
  .form-group {
    flex-direction: column; /* Stack label and input vertically */
    align-items: flex-start; /* Align items to the start of the flex container */
  }

  .form-group label {
    width: 100%;
    text-align: left;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    margin-left: 0px;
  }

  .checkbox-group {
    margin-left: 0px;
  }

  .admin-page-wrapper.main-content {
    margin-left: 0;
    padding-left: 1rem;
    padding-right: 1rem;
    max-width: 100vw;
  }

  .admin-page-wrapper.main-content.with-sidebar-collapsed {
    margin-left: 0;
    max-width: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;EAChC,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,wBAAwB;EACxB,yBAAyB;EACzB,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,iCAAiC;EACjC,+BAA+B;EAC/B,wCAAwC;EACxC,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,4LAA4L;EAC5L,mOAAmO;EACnO,6EAA6E;EAC7E,4BAA4B;EAC5B,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,+BAA+B;EAC/B,mCAAmC;EACnC,yBAAyB;EACzB,gCAAgC;EAChC,mCAAmC;EACnC,6BAA6B;EAC7B,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;;EAEpC,+BAA+B;EAC/B,6CAA6C;EAC7C,2BAA2B;;EAE3B,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;;EAE3C,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;EAC9C,qCAAqC;EACrC,4BAA4B;EAC5B,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,gCAAgC;EAChC,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,sBAAsB;EACtB,8CAA8C;EAC9C,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB,EAAE,4DAA4D;AACjF;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,sDAAsD;EACtD,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,2HAA2H;AAC7H;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,4BAA4B;EAC5B,gCAAgC;EAChC,8DAA8D;EAC9D,kDAAkD;EAClD,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,uCAAuC;EACvC,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;EACtB,sDAAsD;EACtD,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAuC;EACvC,mBAAmB;EACnB,2DAA2D;EAC3D,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,wEAAwE;EACxE,2CAA2C;EAC3C,gBAAgB;EAChB,+DAA+D;EAC/D,8DAA8D;AAChE;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,uCAAuC;EACvC,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;EAC3B,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB,EAAE,qCAAqC;IAC7D,uBAAuB,EAAE,mDAAmD;EAC9E;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n:root {\n  --text-color: #e2e2e2;\n  --bg-color: #2e2f31;\n  --bg-color-secondary: #161b22;\n  --bg-color-tertiary: #21262c;\n  --border-color: #30363d;\n  --box-shadow: #282a32;\n  --card-shadow: rgba(0, 0, 0, .3);\n  --black: #fff;\n  --dark-grey: #999;\n  --light-grey: #666;\n  --white: #000;\n  --grey3: #bbb;\n  --grey12: #333;\n  --grey14: #111;\n  --bg-color-light: #161b22;\n  --bg-color-back: #2a112a;\n  --bg-color-float: #161b22;\n  --bg-color-blur: rgba(37, 39, 42, .9);\n  --bg-color-float-blur: rgba(22, 27, 34, .9);\n  --text-color-light: #e5e5e5;\n  --text-color-lighter: #e8e8e8;\n  --text-color-bright: #eeeeee;\n  --border-color-light: #2e333a;\n  --border-color-dark: #394048;\n  --theme-color: #3eaf7c;\n  --navbar-height: 3.75rem;\n  --navbar-horizontal-padding: 1.5rem;\n  --navbar-vertical-padding: 0.7rem;\n  --navbar-mobile-height: 3.25rem;\n  --navbar-mobile-horizontal-padding: 1rem;\n  --navbar-mobile-vertical-padding: .5rem;\n  --navbar-bg-color: var(--bg-color-blur);\n  --sidebar-bg-color: var(--bg-color-blur);\n  --sidebar-width: 18rem;\n  --sidebar-mobile-width: 16rem;\n  --content-width: 780px;\n  --home-page-width: 1160px;\n  --font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", STHeiti, \"Microsoft YaHei\", SimSun, sans-serif;\n  --font-family-heading: Georgia Pro, Crimson, Georgia, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", STHeiti, \"Microsoft YaHei\", SimSun, sans-serif;\n  --font-family-mono: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n  --line-numbers-width: 2.5rem;\n  --color-transition: .3s ease;\n  --transform-transition: .3s ease;\n  --vp-bg: var(--bg-color);\n  --vp-bgl: var(--bg-color-light);\n  --vp-bglt: var(--bg-color-tertiary);\n  --vp-c: var(--text-color);\n  --vp-cl: var(--text-color-light);\n  --vp-clt: var(--text-color-lighter);\n  --vp-brc: var(--border-color);\n  --vp-brcd: var(--border-color-dark);\n  --vp-tc: var(--theme-color);\n  --vp-tcl: var(--theme-color-light);\n  --vp-ct: var(--color-transition);\n  --vp-tt: var(--transform-transition);\n\n  --warning-border-color: #e6a700;\n  --warning-code-bg-color: rgb(230 167 0 / 15%);\n  --warning-bg-color: #4d3800;\n\n  --theme-color-dark: #389e70;\n  --theme-color-light: #4abf8a;\n  --theme-color-mask: rgba(62, 175, 124, .15);\n\n  --badge-tip-color: #42b983;\n  --badge-warning-color: #f4cd00;\n  --badge-danger-color: #f55;\n  --badge-info-color: #0295ff;\n  --badge-note-color: #666;\n}\n\n[data-bs-theme=\"dark\"] .navbar {\n  --bs-navbar-color: #ea3377; \n}\n\n[data-bs-theme=\"dark\"] {\n  --bs-body-bg: #140814; \n  --bg-color: #2a112a;  \n  --bs-secondary-color: rgba(255, 255, 255, 0.5);\n  --bg-color-blur: rgba(42, 17, 41, .9);\n  --bs-nav-link-color: #ea3377; \n  --bs-link-color: #ea3377; \n  --bs-emphasis-color-rgb: #ea3377; \n  --text-color: #fff; \n  --link-color: #ea3377;\n  --link-hover-color: #fff;\n  --bg-color-navbar: #1b1020;\n  --bg-color-navbar-hover: #841a41;\n  --bs-border-color: #664e57;\n  --bs-secondary-bg: #1b1020;\n  --bs-link-color-rgb: 234, 51, 119;\n}\n\n.theme-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.admin-page-wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0 auto;\n  flex-direction: column;\n  justify-content: space-between;\n  box-sizing: border-box;\n  padding-top: calc(var(--navbar-height) + 2rem);\n  padding-bottom: 2rem;\n  min-height: calc(100vh - var(--navbar-height));\n}\n\n.admin-page-wrapper.main-content {\n  margin-left: 250px;\n  transition: margin-left 0.3s ease;\n  padding-left: 2rem;\n  padding-right: 2rem;\n  max-width: calc(100vw - 250px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-x: hidden;\n}\n\n.admin-page-wrapper.main-content > * {\n  width: 100%;\n  max-width: 1200px; /* Adjust this value based on your preferred content width */\n}\n\nfooter {\n  margin: .5rem 1rem;\n  font-size: 14px;\n}\n\n.footer-wrapper {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding-block: .75rem;\n  padding-inline: calc(var(--sidebar-space) + 2rem) 2rem;\n  border-top: 1px solid var(--border-color);\n  color: var(--dark-grey);\n  text-align: center;\n  transition: border-top-color var(--color-transition),background var(--color-transition),padding var(--transform-transition);\n}\n\n.footer-wrapper > div {\n  flex: 1;\n  padding: 0 1rem;\n  min-width: 200px;\n}\n\n.footer-wrapper .footer {\n  text-align: left;\n}\n\n.footer-wrapper .copyright {\n  text-align: right;\n}\n\n.footer-wrapper .terms {\n  text-align: center;\n}\n\n/* Modal */\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 800px;\n  --bs-modal-padding: 1rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: #e2e2e2;\n  --bs-modal-bg: #1e1e1e;\n  --bs-modal-border-color: rgb(255 255 255 / 18%);\n  --bs-modal-border-width: 1px;\n  --bs-modal-border-radius: 0.5rem;\n  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  --bs-modal-inner-border-radius: calc(0.5rem - 1px);\n  --bs-modal-header-padding-x: 1rem;\n  --bs-modal-header-padding-y: 1rem;\n  --bs-modal-header-padding: 1rem 1rem;\n  --bs-modal-header-border-color: #49494c;\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: 1px;\n}\n\n.modal-backdrop {\n  opacity:0.9 !important;\n}\n\n.modal-content {\n  background: none;\n  /*border: transparent;*/\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: none;\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: none;\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n\n/* Buttons */\n[data-bs-theme=\"light\"] .btn-primary {\n  --bs-btn-color: #000;\n  --bs-btn-bg: #ea3377;\n  --bs-btn-border-color: #b8e986;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #ff4c4c;\n  --bs-btn-hover-border-color: #ff4c4c;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #ff4c4c;\n  --bs-btn-active-border-color: #ff4c4c;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #d7e5c9;\n  --bs-btn-disabled-border-color: #d7e5c9;\n}\n\n[data-bs-theme=\"dark\"] .btn-primary {\n  --bs-btn-color: #ffaecc;\n  --bs-btn-bg: #8d1642;\n  --bs-btn-border-color: #ea3377;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #ff4c4c;\n  --bs-btn-hover-border-color: #ff4c4c;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #ff4c4c;\n  --bs-btn-active-border-color: #ff4c4c;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #d7e5c9;\n  --bs-btn-disabled-border-color: #d7e5c9;\n}\n\n[data-bs-theme=\"light\"] .btn-outline-primary {\n  --bs-btn-color: #000;\n  --bs-btn-border-color: #000000;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #ff4c4c;\n  --bs-btn-hover-border-color: #ff4c4c;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #ff4c4c;\n  --bs-btn-active-border-color: #ff4c4c;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #d7e5c9;\n  --bs-btn-disabled-border-color: #d7e5c9;\n  --bs-gradient: none;\n}\n\n[data-bs-theme=\"dark\"] .btn-outline-primary {\n  --bs-btn-color: #ffffff;\n  --bs-btn-border-color: #fffefe;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: rgba(42, 17, 41, .9);\n  --bs-btn-hover-border-color: #ff4c4c;\n  --bs-btn-focus-shadow-rgb: 49, 132, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #8d1642;\n  --bs-btn-active-border-color: #ff4c4c;\n  --bs-btn-disabled-color: #fff;\n  --bs-btn-disabled-bg: #d7e5c9;\n  --bs-btn-disabled-border-color: #d7e5c9;\n  --bs-gradient: none;\n}\n\n.filter-buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.title{\n  margin-bottom: 30px;\n}\n\n.card {\n  box-shadow: 0 0 41px 4px #00000080;\n}\n\n.card-container {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Form Group */\n.form-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.form-group input,\n.form-group textarea {\n  border-width: 2px;\n}\n\n.form-group label {\n  width: 200px;\n  margin-right: 10px;\n  text-align: right;\n}\n\n.form-select {\n  border-width: 2px;\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  width: 100%;\n}\n\n.checkbox-item {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.tooltip {\n  position: absolute !important;\n}\n\n/* Toggle Switch Styles - Shared component */\n.custom-toggle {\n  position: relative;\n  display: inline-block;\n  width: 35px;\n  height: 15px;\n}\n\n.custom-toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: .4s;\n  border-radius: 34px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 13px;\n  width: 13px;\n  left: 3px;\n  bottom: 1px;\n  background-color: white;\n  transition: .4s;\n  border-radius: 50%;\n}\n\ninput:checked + .slider {\n  background-color: #2196F3;\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  transform: translateX(18px);\n}\n\n/* React Select - Dark theme styles */\n.dark-select__control {\n  background-color: var(--bs-body-bg) !important;\n  color: #e0e0e0 !important;\n  border: 2px solid var(--bs-border-color) !important;\n}\n\n.dark-select__placeholder {\n  color: #aaa !important;\n}\n\n.dark-select__control--is-focused {\n  border-color: #6200ea !important;\n  box-shadow: 0 0 5px rgba(98, 0, 234, 0.8) !important;\n}\n\n.dark-select__menu {\n  background-color: #1f1f1f !important;\n  color: #e0e0e0 !important;\n}\n\n.dark-select__option {\n  background-color: #1f1f1f !important;\n  color: #e0e0e0 !important;\n}\n\n.dark-select__option--is-selected {\n  background-color: #6200ea !important;\n  color: #fff !important;\n}\n\n.dark-select__option--is-focused {\n  background-color: #333 !important;\n}\n\n.dark-select__single-value {\n  color: #fff !important;\n}\n\n.dark-select__input-container {\n  color: #fff !important;\n}\n\n/* CRT Model Tag Styles */\n.selected-crt-models {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.crt-model-tag {\n  display: inline-flex;\n  align-items: center;\n  background-color: #f0f0f0;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 14px;\n}\n\n.crt-model-tag .btn-close {\n  width: 16px;\n  height: 16px;\n  margin-left: 8px;\n  padding: 0;\n  font-size: 10px;\n  opacity: 0.5;\n}\n\n.crt-model-tag .btn-close:hover {\n  opacity: 1;\n}\n\n.admin-page-wrapper.main-content.with-sidebar-collapsed {\n  margin-left: 85px;\n  max-width: calc(100vw - 85px);\n}\n\n@media (max-width: 768px) {\n  .form-group {\n    flex-direction: column; /* Stack label and input vertically */\n    align-items: flex-start; /* Align items to the start of the flex container */\n  }\n\n  .form-group label {\n    width: 100%;\n    text-align: left;\n  }\n\n  .form-group input,\n  .form-group select,\n  .form-group textarea {\n    margin-left: 0px;\n  }\n\n  .checkbox-group {\n    margin-left: 0px;\n  }\n\n  .admin-page-wrapper.main-content {\n    margin-left: 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    max-width: 100vw;\n  }\n\n  .admin-page-wrapper.main-content.with-sidebar-collapsed {\n    margin-left: 0;\n    max-width: 100vw;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
